import React, { useState } from "react";
import { Mail, Loader2, Send } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useLang } from "@/context/LanguageContext";
import { trackEvent } from "@/lib/analytics";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** After a Google Play purchase: optional e-mail to receive the receipt + restore link for other devices. */
export default function ReceiptPrompt({ token, onClose }) {
  const { lang, t } = useLang();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const send = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/payments/receipt`, { token, email: email.trim(), origin_url: window.location.origin, lang });
      trackEvent("receipt_email"); toast.success(t("receipt_sent").replace("{email}", email.trim())); onClose();
    } catch { toast.error(t("payment_failed")); } finally { setBusy(false); }
  };
  return (
    <Dialog open={Boolean(token)} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-sm" data-testid="receipt-dialog">
        <DialogHeader><DialogTitle className="font-display flex items-center gap-2"><Mail className="w-5 h-5 text-ochre" /> {t("receipt_title")}</DialogTitle><DialogDescription>{t("receipt_sub")}</DialogDescription></DialogHeader>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nome@email.com" className="w-full rounded-2xl border border-stoneLine bg-sand/40 px-4 py-3 text-base" data-testid="receipt-email" />
        <div className="flex gap-2">
          <button onClick={onClose} className="flex-1 rounded-full border border-stoneLine px-4 py-2.5 text-sm hover:bg-sandDeep/50" data-testid="receipt-skip">{t("receipt_skip")}</button>
          <button onClick={send} disabled={!ok || busy} className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-ink text-sand px-4 py-2.5 text-sm font-semibold hover:bg-ochre disabled:opacity-40" data-testid="receipt-send">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} {t("receipt_send")}</button>
        </div>
        <p className="text-[11px] text-muted-foreground">{t("receipt_privacy")}</p>
      </DialogContent>
    </Dialog>
  );
}
